module.exports = { "default": require("core-js/library/fn/reflect/get"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/reflect/get.js
// module id = 326
// module chunks = 0